import microuniversoApi from "app/api/microuniversoApi";
import { DadosOrdemProducao, DadosOrdemProducaoCombinados, DadosSalvarOrdemProducao } from "app/types/OrdemProducao";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";

import { DadosOrdemDeProducao } from "./consulta-ordem-de-producao/ConsultaOrdemDeProducao";

import { CancelarGeracaoOrdemDeProducao } from "./CancelarGeracaoOrdemProducao";

const estilosBotoes = require("../../estilos/botoes.module.scss").default;
const estilosInputs = require('../../estilos/inputs.module.scss').default

export type CancelarGeracaoOrdemProducaoContainerProps = {
    onVoltar: () => void
    onRemover: () => boolean
    //onRemoverProdutoSelecionado: (produto: ProdutoFiltrado) => void
    passos: Dict<string, () => void>;
    ordemProducao?: Partial<DadosOrdemDeProducao>
}

export const CancelarGeracaoOrdemProducaoContainer = (props: CancelarGeracaoOrdemProducaoContainerProps) => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])
    const [processando, setProcessando] = useState(false)
    const [ordemProducao, setOrdemProducao] = useState<Partial<DadosOrdemProducaoCombinados>>(props.ordemProducao)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    
    const onExcluirControleDeExclusividade = async () => {
        try {
            globalMU.blockUI()
            await microuniversoApi.Comum.excluirControleDeExclusividade(props.ordemProducao.NumeroPedido.toString(), "PEDICLICAD");
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onObterDados = async () => {
        
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.OrdemProducao.ObterDadosOrdemProducao({
                CodigoItemPedido: props.ordemProducao.CodigoItem,
                CodigoOrdemProducao: props.ordemProducao.CodigoOrdemProducao,
                CodigoProduto: props.ordemProducao.CodigoProduto,
                QuantidadeItem: props.ordemProducao.QuantidadeItem,
                CodigoFilial: props.ordemProducao.CodigoFilialOP,
                Nivel: props.ordemProducao.Nivel,

            }, props.ordemProducao.NumeroPedido);

            if (!("HasErrors" in resposta)) {

                if (props.ordemProducao?.CodigoOrdemProducao > 0) {
                    setOrdemProducao(resposta.Dados)
                } else {
                    setOrdemProducao(resposta.DadosInclusao)
                }

            } else if (resposta["Error"]["Error"]?.includes("já está em uso por outro usuário")) {
                setOrdemProducao(null)
                onVoltar()
            }
        }
        catch (e) {
            tratamentoErroPadrao(e)
            setOrdemProducao(null)
        }
        finally {
            globalMU.unblockUI();
            setProcessando(false)
        }
    }
   
    const onVoltar = () => {
        
        props.onRemover()
        props.onVoltar()
        props.ordemProducao != null && onExcluirControleDeExclusividade();
    }


    const onGerarCancelamento = async () => {
        
        if (!isMounted.current) return
        try {
            globalMU.blockUI()
            setProcessando(true)

            const resposta = await microuniversoApi.OrdemProducao.SalvarOrdemProducao({
                Dados: {
                    ...ordemProducao as DadosSalvarOrdemProducao,
                    CodigoOrdemProducao: ordemProducao.Id,
                    NumeroOrdemEntrada: ordemProducao.NumeroEntrada,
                    CodigoSituacao: 40093, // Cancelada -- PA 471071
                    DescricaoProduto: ordemProducao.Descricao, // 471071
                },
                // DadosInsumoOrdemProducao: null,
                // SenhaLiberacao: null,
                // DadosHistoricoOrdemProducao: null
            })

            if (resposta?.Resultado?.Sucesso) {
                globalMU.showSuccessMessage(resposta?.Resultado?.MensagemSucesso)
                onVoltar()
            }
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            setProcessando(false)
            globalMU.unblockUI()
        }
    }


    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    useEffect(() => {
        setProcessando(false)
        passosInterno.current.set("Cancelar Geracao de Ordem de Produção", () => { })

        onObterDados()

        $.connection.hub.disconnected(function () {
            console.log("$.connection.hub.disconnected")
        })
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno?.current?.keysToList()}
                id="CancelarGeracaoOrdemProducaoContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                processando={processando}
            />


            <CancelarGeracaoOrdemDeProducao
                onGerarCancelamento={onGerarCancelamento}
                ordemProducao={props.ordemProducao}
                processando={processando}
            />
            
            <section style={{ marginBottom: "100px" }} />
        </>
    )
}